import { initializeApp } from "firebase/app";
import { initializeAuth, browserSessionPersistence } from "firebase/auth";

// Public Firebase web configuration, shared with the existing XPress account system.
export const auth = initializeAuth(initializeApp({
  apiKey: "AIzaSyCWsh5wSHSIBwndmcSqhh5c9jwGZeIwlDQ",
  authDomain: "xappstore-533b8.firebaseapp.com",
  projectId: "xappstore-533b8",
  appId: "1:996074459120:web:bb2ef275f6dc308eb89735"
}), { persistence: browserSessionPersistence });
